module.exports = __webpack_public_path__ + "d664201f/img/at-icon.5d6fc5d8.svg";